export default __webpack_public_path__ + "images/RER.38462e4.png";